export default __webpack_public_path__ + "static/media/female_avtar.63c6d787.png";